import type React from 'react';

import { useAppState } from '../AppStateProvider';
import { EmptyStateView } from '../components/EmptyStateView';
import { Header } from '../components/Header';
import { LoadingView } from '../components/LoadingView';
import { useCompaniesQuery } from '../features/company/useCompaniesQuery';
import { useDisabledPageView } from '../hooks/useDisabledPageView';

import { isCompanyDataPresent } from './company-overview/MultipleDomainsContainer/utils';
import { CompanyPage } from './CompanyPage';

export const GoogleSheetsPage: React.FC = () => {
  const companiesQuery = useCompaniesQuery();
  const { collectedDomains } = useAppState();

  const { isDisabledPageVisible, disabledPageView } = useDisabledPageView();

  const isCompaniesDataValid = Boolean(
    companiesQuery?.data?.length && companiesQuery?.data.some((company) => isCompanyDataPresent(company))
  );

  if (isDisabledPageVisible) {
    return disabledPageView;
  }

  if (companiesQuery.isLoading) {
    return (
      <>
        <Header />
        <LoadingView />
      </>
    );
  }

  if (collectedDomains && !isCompaniesDataValid) {
    return (
      <>
        <Header />
        <EmptyStateView
          img="/images/empty-state-lens.svg"
          variant="lens-rised"
          messageKey="google_sheets.empty_state.message"
        />
      </>
    );
  }

  return <CompanyPage />;
};
